export default {
  apiUrl: process.env.GATSBY_HS_APIURI,
  authUrl: process.env.GATSBY_HS_AUTHURI,
  targetUrl: process.env.GATSBY_HS_TARGETURL,
  loginStatus: process.env.GATSBY_HS_LOGINSTATUS,
  titlePrefix: process.env.GATSBY_HS_TITLE_PREFIX,
  sentryDSN: process.env.GATSBY_SENTRY_DSN || "",
};
